<template>
  <div>
    <v-dialog
      v-model="dialog"
      max-width="1000"
      persistent
    >
      <!-- APP BAR -->
      <v-app-bar color="#002733" flat>
        <div class="text-center w-100" style="color: white;">
          <h1>{{ $t('career.title') }}</h1>
        </div>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- CONTENT -->
      <v-container style="background-color: white;">
        <v-row>
          <v-col cols="12">
            <v-card flat>
              <v-card-title>
                Aceitamos candidaturas espontâneas! Envia a tua candidatura para:
              </v-card-title>
              <v-card-subtitle>
                candidaturas@dreamdealtech.pt
              </v-card-subtitle>

              <!-- TABELA -->
              <v-data-table
                v-model:expanded="expanded"
                :headers="headers"
                :items="items"
                item-value="id"
                show-expand
                expand-on-click
                class="elevation-4 mt-4"
              >
                <template #item.position="{ item }">
                  <p class="font-weight-bold mt-4">{{ item.position }}</p>
                </template>

                <template #expanded-row="{ columns, item }">
                  <tr>
                    <td :colspan="columns.length">
                      <v-card flat class="pa-4">
                        <v-card-title>Job description</v-card-title>
                        <v-card-text>{{ item.job_description }}</v-card-text>

                        <v-card-title>Qualifications:</v-card-title>
                        <v-card-text>
                          <ul>
                            <li v-for="q in item.qualifications" :key="q">{{ q }}</li>
                          </ul>
                        </v-card-text>

                        <v-card-title>Good to have:</v-card-title>
                        <v-card-text>
                          <ul>
                            <li v-for="q in item.good_to_have" :key="q">{{ q }}</li>
                          </ul>
                        </v-card-text>

                        <v-card-title>Conditions:</v-card-title>
                        <v-card-text>
                          <ul>
                            <li v-for="q in item.conditions" :key="q">{{ q }}</li>
                          </ul>
                        </v-card-text>

                        <v-card-title>What's in it for you:</v-card-title>
                        <v-card-text>
                          <ul>
                            <li v-for="q in item.for_you" :key="q">{{ q }}</li>
                          </ul>
                        </v-card-text>

                        <v-card-title>What you can expect:</v-card-title>
                        <v-card-text>
                          <ul>
                            <li v-for="q in item.expect" :key="q">{{ q }}</li>
                          </ul>
                        </v-card-text>
                      </v-card>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const dialog = ref(false)
const expanded = ref([])

const headers = [
  { title: 'Position', key: 'position', sortable: false },
  { title: '', key: 'data-table-expand', align: 'end' }
]

const items = [
  {
    id: 1,
    position: 'Sales consultant',
    job_description:
      'Estamos à procura de um Consultor de Vendas motivado e experiente para se juntar à nossa equipa de vendas. Como consultor de vendas, será responsável por ajudar os nossos clientes a compreender os nossos produtos e serviços, bem como trabalhar em estreita colaboração com eles para encontrar soluções personalizadas que atendam às suas necessidades. O candidato ideal deve ter excelentes habilidades de comunicação e vendas, bem como alguma experiência comprovada em atendimento ao cliente. Espera-se que o candidato tenha conhecimento em técnicas de vendas e estratégia.',
    qualifications: [
      'Facilidade em trabalhar com programas informáticos;',
      'Desenvolver e manter relacionamentos de longo prazo com os clientes;',
      'Compreender as necessidades e objetivos dos clientes e apresentar soluções personalizadas;',
      'Alcançar metas de vendas mensais e trimestrais',
      'Fortes habilidades de comunicação'
    ],
    good_to_have: [
      'Experiencia com métodos ágeis',
      'Experiencia no mercado de IT',
      'Experiencia comprovada'
    ],
    conditions: [
      'Salário ajustável à experiência.',
      'Bónus de performance.'
    ],
    for_you: [
      'Um espaço onde poderá trazer impacto e fazer crescer a empresa!'
    ],
    expect: [
      'Uma conversa com os nossos recrutadores.',
      'Entrevista com o nosso CEO.'
    ]
  }
]

function openDialog () {
  dialog.value = true
}
</script>
